// HistorialTurnos.jsx
import * as React from "react";
import {
  Box,
  Button,
  Chip,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Stack,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import {
  IosShare,
  Print,
  Add,
  Search,
} from "@mui/icons-material";
import AppTheme from "../../../../shared-theme/AppTheme";
import AppShellCobros from "../components/appshellcobros";
import { StyledCellHeader } from "../../../../components/StyledCellHeader";
import { formatNumberWithCommas } from "../../../../utils/generalFunctions";

const drawerWidth = 260;

const turns = [
  {
    id: "T20240715-001",
    cashier: "Emily Carter",
    branch: "Calle Principal",
    opening: "$1,000.00",
    closing: "$1,200.00",
    discrepancy: { value: "$200.00", positive: true },
    openAt: "Jul 15, 2024, 8:00 AM",
    status: { label: "Cerrado", color: "success" },
  },
  {
    id: "T20240715-002",
    cashier: "David Lee",
    branch: "Centro",
    opening: "$1,500.00",
    closing: "$1,450.00",
    discrepancy: { value: "($50.00)", positive: false },
    openAt: "Jul 15, 2024, 9:00 AM",
    status: { label: "Cerrado", color: "success" },
    zebra: true,
  },
  {
    id: "T20240716-001",
    cashier: "Sophia Clark",
    branch: "Zona Norte",
    opening: "$800.00",
    closing: "$1,050.00",
    discrepancy: { value: "$250.00", positive: true },
    openAt: "Jul 16, 2024, 8:30 AM",
    status: { label: "Abierto", color: "info" },
  },
  {
    id: "T20240716-002",
    cashier: "Ethan Brown",
    branch: "Calle Principal",
    opening: "$1,200.00",
    closing: "$1,180.00",
    discrepancy: { value: "($20.00)", positive: false },
    openAt: "Jul 16, 2024, 9:15 AM",
    status: { label: "Auditado", color: "warning" },
    zebra: true,
  },
];

export default function HistorialTurnos(props) {
  const [branch, setBranch] = React.useState("all");
  const [cashier, setCashier] = React.useState("all");
  const [date, setDate] = React.useState("");
  const [query, setQuery] = React.useState("");
  const [turns, setTurns] = React.useState([]);
  const [filteredTurns, setFilteredTurns] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  // Extract unique branches and users from turns data
  const filterOptions = React.useMemo(() => {
    if (turns.length === 0) {
      return {
        branches: [],
        users: []
      };
    }

    // Extract unique branches from turns data
    const branches = [...new Set(turns.map(turn => turn.sucursal_nombre).filter(Boolean))].sort();
    
    // Extract unique users from turns data
    const users = [...new Set(turns.map(turn => turn.usuario_nombre).filter(Boolean))].sort();

    return {
      branches,
      users
    };
  }, [turns]);

  // Fetch turns data
  const fetchTurns = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/pos/shifts/all/${localStorage.getItem('idcompany')}`, {
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        }
      });
      const data = await response.json();
      setTurns(data.summary || []);
      setFilteredTurns(data.summary || []);
    } catch (error) {
      console.error('Error fetching turns:', error);
    } finally {
      setLoading(false);
    }
  };

  // Apply filters
  const applyFilters = () => {
    let filtered = [...turns];

    // Filter by query (search in turn ID, cashier name)
    if (query) {
      filtered = filtered.filter(turn => 
        turn.id?.toLowerCase().includes(query.toLowerCase()) ||
        turn.usuario_nombre?.toLowerCase().includes(query.toLowerCase())
      );
    }

    // Filter by branch
    if (branch !== "all") {
      filtered = filtered.filter(turn => turn.sucursal_nombre === branch);
    }

    // Filter by cashier
    if (cashier !== "all") {
      filtered = filtered.filter(turn => turn.usuario_nombre === cashier);
    }

    // Filter by date
    if (date) {
      filtered = filtered.filter(turn => {
        const turnDate = new Date(turn.fecha_apertura).toISOString().split('T')[0];
        return turnDate === date;
      });
    }

    setFilteredTurns(filtered);
  };

  // Clear filters
  const clearFilters = () => {
    setBranch("all");
    setCashier("all");
    setDate("");
    setQuery("");
    setFilteredTurns(turns);
  };

  React.useEffect(() => {
    fetchTurns();
  }, []);

  React.useEffect(() => {
    applyFilters();
  }, [turns, query, branch, cashier, date]);

  return (
    <AppTheme {...props}>
              <AppShellCobros title="Bankivo · Centro de Cobros">
          <Box sx={{ p: 2, mr: 5 }}>
            {/* Header + Actions */}
            <Stack
              direction={{ xs: "column", md: "row" }}
              justifyContent="space-between"
              alignItems={{ xs: "flex-start", md: "center" }}
              spacing={2}
              sx={{ mb: 3 }}
            >
              <Box>
                <Typography variant="h4" fontWeight={800}>
                  Historial y Gestión de Turnos
                </Typography>
                <Typography color="text.secondary" sx={{ mt: 0.5 }}>
                  Rastrea y gestiona turnos de cajeros en todas las sucursales
                </Typography>
              </Box>

              <Stack direction="row" spacing={1}>
              </Stack>
            </Stack>

                      {/* Filters */}
            <Paper sx={{ p: 2.5, mb: 3, backgroundColor: "white" }}>
              <Grid container spacing={2} alignItems="flex-end">
                <Grid item size={4}>
                  <Box>
                    <Typography variant="body2" color="text.secondary" sx={{ fontWeight: "bold", mb: 1, textAlign: "left",marginLeft:1 }}>  
                      Buscar
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Buscar por ID de turno, nombre de cajero..."
                      value={query}
                      onChange={(e) => setQuery(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item size={2}>
                  <Box>
                    <Typography variant="body2" color="text.secondary" sx={{ fontWeight: "bold", mb: 1, textAlign: "left",marginLeft:1 }}>
                      Sucursal
                    </Typography>
                    <FormControl fullWidth>
                      <Select
                        sx={{ backgroundColor: "white" }}
                        value={branch}
                        onChange={(e) => setBranch(e.target.value)}
                        displayEmpty
                      >
                        <MenuItem value="all">Todas las Sucursales</MenuItem>
                        {filterOptions.branches.map((branchName) => (
                          <MenuItem key={branchName} value={branchName}>
                            {branchName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
                <Grid item size={2}>
                  <Box>
                    <Typography variant="body2" color="text.secondary" sx={{ fontWeight: "bold", mb: 1, textAlign: "left",marginLeft:1 }}>
                      Fecha
                    </Typography>
                    <TextField
                      fullWidth
                      type="date"
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Box>
                </Grid>
                <Grid item size={2}>
                  <Box>
                    <Typography variant="body2" color="text.secondary" sx={{ fontWeight: "bold", mb: 1, textAlign: "left",marginLeft:1 }}>
                      Cajero
                    </Typography>
                    <FormControl fullWidth>
                      <Select
                        sx={{ backgroundColor: "white" }}
                        value={cashier}
                        onChange={(e) => setCashier(e.target.value)}
                        displayEmpty
                      >
                        <MenuItem value="all">Todos los Cajeros</MenuItem>
                        {filterOptions.users.map((userName) => (
                          <MenuItem key={userName} value={userName}>
                            {userName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Grid>
                <Grid item size={2}>
                  <Box>
                    <Typography variant="body2" color="text.secondary" sx={{ fontWeight: "bold", mb: 1, textAlign: "left",marginLeft:1 }}>
                      &nbsp;
                    </Typography>
                    <Button fullWidth variant="outlined" onClick={clearFilters}>
                      Limpiar Filtros
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Paper>

                      {/* KPI Cards */}
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item size={4}>
                <Paper sx={{ p: 2.5, backgroundColor: "white" }}>
                  <Typography variant="body2" color="text.secondary">
                    Total de Turnos
                  </Typography>
                  <Typography variant="h4" sx={{ mt: 1, color: "primary.main", fontWeight: 800 }}>
                    {filteredTurns.length}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item size={4}>
                <Paper sx={{ p: 2.5, backgroundColor: "white" }}>
                  <Typography variant="body2" color="text.secondary">
                    Total Procesado
                  </Typography>
                  <Typography variant="h4" sx={{ mt: 1, color: "primary.main", fontWeight: 800 }}>
                    {formatNumberWithCommas(filteredTurns.reduce((acc, t) => acc + parseFloat(t.total_ventas_monto || 0) + parseFloat(t.total_monto_prestamos || 0) + parseFloat(t.total_monto_iniciales || 0) + parseFloat(t.total_cargos || 0), 0).toFixed(2))}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item size={4}>
                <Paper sx={{ p: 2.5, backgroundColor: "white" }}>
                  <Typography variant="body2" color="text.secondary">
                    Discrepancias Pendientes
                  </Typography>
                  <Typography variant="h4" sx={{ mt: 1, color: "#EF4444", fontWeight: 800 }}>
                    {filteredTurns.filter(t => t.estado === "cerrado" && (parseFloat(t.total_ventas_monto || 0) + parseFloat(t.total_monto_prestamos || 0) + parseFloat(t.total_monto_iniciales || 0) + parseFloat(t.total_cargos || 0) - parseFloat(t.monto_inicial || 0)) >= 0).length}
                  </Typography>
                </Paper>
              </Grid>
            </Grid>

          {/* Table */}
          <Paper>
            <TableContainer>
              <Table>
                 <TableHead sx={{ bgcolor: "grey.50" }}>
                    <TableRow>
                      <StyledCellHeader>Nombre del Cajero</StyledCellHeader>
                      <StyledCellHeader>Sucursal</StyledCellHeader>
                      <StyledCellHeader>Saldo de Apertura</StyledCellHeader>
                      <StyledCellHeader>Saldo de Cierre</StyledCellHeader>
                      <StyledCellHeader>Discrepancia</StyledCellHeader>
                      <StyledCellHeader>Fecha/Hora de Apertura</StyledCellHeader>
                      <StyledCellHeader>Fecha/Hora de Cierre</StyledCellHeader>
                      <StyledCellHeader>Estado</StyledCellHeader>
                   </TableRow>
                  </TableHead>
                <TableBody sx={{backgroundColor: "white"}}>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        <Typography variant="body2" color="text.secondary">
                          Cargando datos...
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : filteredTurns.length > 0 ? (
                    filteredTurns.map((t, i) => {
                      const totalProcesado = parseFloat(t.total_ventas_monto || 0) + parseFloat(t.total_monto_prestamos || 0) + parseFloat(t.total_monto_iniciales || 0) + parseFloat(t.total_cargos || 0);
                      const montoInicial = parseFloat(t.monto_inicial || 0);
                      const discrepancia = totalProcesado - montoInicial;
                      
                      return (
                        <TableRow
                          key={t.id || i}
                          hover
                          sx={{
                            bgcolor: "white",
                          }}
                        >
                          <TableCell sx={{ fontWeight: 600 }}>{t.usuario_nombre || 'N/A'}</TableCell>
                          <TableCell>{t.sucursal_nombre || 'N/A'}</TableCell>
                          <TableCell>{formatNumberWithCommas(montoInicial.toFixed(2))}</TableCell>
                          <TableCell>{formatNumberWithCommas(totalProcesado.toFixed(2))}</TableCell>
                          <TableCell sx={{ 
                            fontWeight: 700, 
                            color: discrepancia > 0 ? "success.main" : discrepancia < 0 ? "error.main" : "text.primary" 
                          }}>
                            {discrepancia.toFixed(2)}
                          </TableCell>
                          <TableCell>{t.fecha_apertura || 'N/A'}</TableCell>
                          <TableCell>{t.fecha_cierre || 'N/A'}</TableCell>
                          <TableCell>
                            <Chip
                              label={t.estado || 'N/A'}
                              color={t.estado === "abierto" ? "success" : t.estado === "cerrado" ? "error" : "default"}
                              size="small"
                              variant="outlined"
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        <Typography variant="body2" color="text.secondary">
                          No se encontraron turnos con los filtros aplicados
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

          </Paper>
        </Box>
      </AppShellCobros>
    </AppTheme>
  );
}
